module.exports = __webpack_public_path__ + "static/industries-healthcarel-image-9e485f448fe743df8826ed8768b9471b.jpg";